import PropTypes from 'prop-types';
import colors from 'assets/theme/base/colors';
import { useIntl } from 'react-intl';
// material

// ----------------------------------------------------------------------

Digitech.propTypes = {
  width: PropTypes.string,
  light: PropTypes.bool
};

export default function Digitech({ width, light }) {
  const { formatMessage: msg } = useIntl();
  const color = light ? colors.white.main : colors.black.main;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="digitech"
      version="1.1"
      viewBox="0 0 100.39967 88.709534"
      width={width}
      aria-label={msg({
        id: `company.logo.title`
      })}
    >
      <g id="layer1" transform="translate(-44.294211,-120.44285)">
        <path
          id="path14"
          fill="#763aa0"
          overflow="visible"
          fillOpacity={1}
          d="m 93.611091,129.94633 v -9.50313 h -40.18703 v 30.70543 h 8.89812 v -21.2023 z"
        />
        <path
          id="path18"
          fill="#4bace5"
          overflow="visible"
          fillOpacity={1}
          d="m 133.2352,151.14863 h 8.896 v -30.70578 h -40.18492 v 9.50348 h 31.28892 z"
        />
        <path
          id="path22"
          fill="#c0d41f"
          overflow="visible"
          fillOpacity={1}
          d="m 62.322031,178.44343 h -8.89776 v 30.70895 h 40.18668 v -9.50383 h -31.28892 z"
        />
        <path
          id="path26"
          fill="#e0581d"
          overflow="visible"
          fillOpacity={1}
          d="m 101.94614,199.64869 v 9.50348 h 40.18492 v -30.7086 h -8.896 v 21.20512 z"
        />
        <path
          id="path38"
          fill={color}
          overflow="visible"
          fillOpacity={1}
          d="m 44.294211,135.69601 c 29.45659,3.65301 68.004969,15.8055 72.356129,22.81132 0.38206,0.60501 0.48225,1.16452 0.31291,1.65629 -2.71074,7.80027 -45.628269,18.88843 -46.059009,19.00273 l -0.27729,0.0709 19.87303,13.94812 c 0,0 53.510739,-15.61112 54.185609,-28.11744 0.11607,-2.10679 -0.97967,-4.06047 -3.67277,-5.83459 -32.35148,-21.38151 -96.057509,-23.7804 -96.697799,-23.80122 z"
        />
        <path
          id="path42"
          fill={color}
          overflow="visible"
          fillOpacity={1}
          d="m 57.507181,182.50281 20.83012,14.81773 9.88659,-3.41136 -19.93229,-13.96683 z"
        />
      </g>
    </svg>
  );
}
